import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-calloutslider").forEach((el) => {
  const container = el.querySelector(".swiper");
  const sliderPagination = el.querySelector(".slider-pagination");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    autoplay: {
      delay: 4000,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: sliderPagination,
      clickable: true,
    },
    centeredSlides: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1536: {
        slidesPerView: 2,
        spaceBetween: 48,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
